import apiClient from "../../services/apiClient";

// 학생 포인트 · 기프티콘 상점(api/reward). 학원 계정으로 부른다.
const BASE = "/api/v1/reward";

export const fetchDefaultRewardPointsAPI = async (assignmentType) => {
  const response = await apiClient.get(`${BASE}/teacher/default-points?type=${encodeURIComponent(assignmentType)}`, { withAuth: true });
  return response.data.reward_points;
};

// 상점을 켠 학원인가(기프티쇼 키 + 활성화 체크). 출제 창마다 부르지 않게 한 번만 묻는다.
let rewardOpenPromise = null;
export const fetchRewardOpenAPI = () => {
  if (!rewardOpenPromise) {
    rewardOpenPromise = apiClient
      .get(`${BASE}/teacher/default-points?type=`, { withAuth: true })
      .then((response) => Boolean(response.data.is_open))
      .catch(() => {
        rewardOpenPromise = null;
        return false;
      });
  }
  return rewardOpenPromise;
};
export const forgetRewardOpen = () => {
  rewardOpenPromise = null;
};

export const fetchRewardAccountAPI = async () => (await apiClient.get(`${BASE}/teacher/account`, { withAuth: true })).data;
export const saveRewardAccountAPI = async (body) => (await apiClient.put(`${BASE}/teacher/account`, body, { withAuth: true })).data;
export const refreshRewardBalanceAPI = async () => (await apiClient.post(`${BASE}/teacher/balance`, {}, { withAuth: true })).data;
export const fetchAcademyRewardProductsAPI = async () => (await apiClient.get(`${BASE}/teacher/products`, { withAuth: true })).data;
export const selectAcademyRewardProductsAPI = async (productIdList, isSelected) =>
  (await apiClient.put(`${BASE}/teacher/products`, { product_id_list: productIdList, is_selected: isSelected }, { withAuth: true })).data;
export const fetchAcademyRewardOrdersAPI = async () => (await apiClient.get(`${BASE}/teacher/orders`, { withAuth: true })).data;

export const fetchAdminRewardProductsAPI = async (keyword = "") =>
  (await apiClient.get(`${BASE}/admin/products?q=${encodeURIComponent(keyword)}`, { withAuth: true })).data;
export const approveAdminRewardProductsAPI = async (productIdList, isApproved) =>
  (await apiClient.put(`${BASE}/admin/products`, { product_id_list: productIdList, is_hq_approved: isApproved }, { withAuth: true })).data;
